/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mHead.vue?vue&type=template&id=a824c760&scoped=true"
import script from "./mHead.vue?vue&type=script&lang=js"
export * from "./mHead.vue?vue&type=script&lang=js"
import style0 from "./mHead.vue?vue&type=style&index=0&id=a824c760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a824c760",
  null
  
)

export default component.exports